import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "app-by-link-tab",
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ByLinkTabComponent {}
